import React from 'react';
import styles from '../../static/css/pages.module.css';
import Header from "../../components/header/priv/header";
import Footer from "../../components/footer/footer";
import Button from "../../components/form/button/button";
import Icon from "../../components/icons/icons";
import ieSvg from "../../components/icons/ieSvg";
import {userAction} from "../../store/actions/userAction";
import {connect} from "react-redux";
import * as consts from "../../store/constants/userInfo";

class PageError extends React.Component {
  componentDidMount() {
    document.title = "FBalance";
    ieSvg();
  }

  handleRedirect = () => {
    window.location.href = this.props.infoLink;
  }

  handleClick = () => {
      this.props.fetchData(process.env.REACT_APP_GATE + "registration/updated/stage", this, consts.REGISTRATION_UPDATED_STAGE);
  }

  render() {
    if (this.props.data.items) {
      if (this.props.data.items.result.status === 'SUCCESS') {
        window.location=process.env.PUBLIC_URL + "/page/home";
        return null;
      }
      else {
        return window.location=process.env.PUBLIC_URL + "/error";
      }
    }
    else {
      return (
        <main>
          <Header type="pubinner" />
          <section className={styles.section}>
            <div className="inner inner_small">
              <div className={`${styles.content} ${styles.simplepage}`}>
                <div>
                  <div className="l-align_center">
                    <Icon name="icon_errorpage" viewbox="0 0 227 120" />
                    <div className={styles.title_page}>
                      {this.props.infoTitle}
                    </div>
                    <div className={styles.simplepage__info}>
                      {this.props.infoErrorMessage?
                        this.props.infoErrorMessage
                        :
                        this.props.infoMessage
                      }
                    </div>
                  </div>
                </div>
                <div className={styles.simplepage__footer}>
                  {
                    this.props.infoButton?
                      <Button title={this.props.infoButton} onClick={this.handleRedirect} />
                      :
                      <span></span>
                  }
                  {
                    this.props.updateButton?
                      <Button title={this.props.updateButton} onClick={this.handleClick} />
                      :
                      <span></span>
                  }
                </div>
              </div>
            </div>
          </section>
          <Footer type="pubinner" />
        </main>
      )
    }
  }
}

const mapStateToProps = state => ({data: state.registrationUpdatedStage})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(userAction(url, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(PageError);